import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumSalesVisitAssociatedEntityType implements BaseEnumType {
  private static allValues: EnumSalesVisitAssociatedEntityType[] = []; // make sure this is top-most
  
  public static none = new EnumSalesVisitAssociatedEntityType(0, "None", "enum_sales_visit_associated_entity_type_none");
  public static outlet = new EnumSalesVisitAssociatedEntityType(1, "Outlet", "enum_sales_visit_associated_entity_type_outlet");
  public static group = new EnumSalesVisitAssociatedEntityType(2, "Group", "enum_sales_visit_associated_entity_type_group");
  public static lead = new EnumSalesVisitAssociatedEntityType(3, "Lead", "enum_sales_visit_associated_entity_type_lead");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumSalesVisitAssociatedEntityType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumSalesVisitAssociatedEntityType.none; }
  public isOutlet() { return this === EnumSalesVisitAssociatedEntityType.outlet; }
  public isGroup() { return this === EnumSalesVisitAssociatedEntityType.group; }
  public isLead() { return this === EnumSalesVisitAssociatedEntityType.lead; }

  public static getValues(): readonly EnumSalesVisitAssociatedEntityType[] {
    return EnumSalesVisitAssociatedEntityType.allValues;
  }

  public static getValuesExcept0(): readonly EnumSalesVisitAssociatedEntityType[] {
    return EnumSalesVisitAssociatedEntityType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumSalesVisitAssociatedEntityType {
    const found = EnumSalesVisitAssociatedEntityType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumSalesVisitAssociatedEntityType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumSalesVisitAssociatedEntityType): EnumSalesVisitAssociatedEntityType {
    const found = name ? EnumSalesVisitAssociatedEntityType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumSalesVisitAssociatedEntityType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumSalesVisitAssociatedEntityType>): boolean {
    return this.key === other?.key;
  }
}